import { Color, ColorPreset, CSSRulesFunction } from "../theme";

import { BannerStatus, BannerVariant } from "./types";

export interface BannerThemingProps {
  /**
   * Configures the appearance of the notification to be either light or dark.
   * This is useful to create enough contrast with different page backgrounds.
   */
  variant: BannerVariant;

  /**
   * Configures the status indicator that will be shown on the notification.
   */
  status: BannerStatus;
}

export const bannerStyle: CSSRulesFunction<BannerThemingProps> = (
  theme,
  { variant }
) => {
  const vl = BannerVariant.Light;
  const vd = BannerVariant.Dark;
  const fb = BannerVariant.FullBleed;

  return [
    {
      [`--banner-${vl}-bg`]: theme.color(Color.White),
      [`--banner-${vl}-fg`]: theme.color(ColorPreset.TextOnLight_01),
      [`--banner-${vd}-bg`]: theme.color(Color.Greystone_DarkMatter),
      [`--banner-${vd}-fg`]: theme.color(ColorPreset.TextOnDark_01),
      [`--banner-${fb}-bg`]: theme.color(ColorPreset.BackgroundLight_03),
      [`--banner-${fb}-fg`]: theme.color(ColorPreset.TextOnLight_01),

      backgroundColor: `var(--banner-${variant}-bg)`,
      color: `var(--banner-${variant}-fg)`,

      borderRadius: variant === fb ? "unset" : theme.radius(1),

      padding: theme.spacing(1.5),

      filter: variant === fb ? "unset" : theme.tokens.elevation[4],

      width: "100%",
      overflow: "auto",
    },
  ];
};
